const styles = () => ({
  // Two equal cards per tab, for both audiences.
  cardGrid: {
    width: '100%',
    maxWidth: 1024,
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    alignItems: 'stretch',
    gap: 24,
    '@media (max-width: 900px)': {
      gridTemplateColumns: '1fr',
    },
  },
})

export default styles
